import { PaymentType } from '@/features/graphql/generated/graphql'
import { parseMoneyInput } from '@/features/shiftCloseouts/utils/moneyInput'
import { z } from 'zod'

const amountSchema = z
    .string()
    .refine((value) => parseMoneyInput(value) !== undefined)
    .transform((value) => parseMoneyInput(value) as string)

export const schema = z.object({
    actualAmounts: z.record(z.nativeEnum(PaymentType), amountSchema),
})
